// src/api/axios.js (or wherever your api instance is defined)
import axios from 'axios';
import store from '@/store';

const api = axios.create({
  // IMPORTANT: Set this to your Laravel backend's URL
  baseURL: 'https://webportal.wanorn.com/backend/', // Example: adjust to your actual backend URL
  withCredentials: true, // If you plan to use Sanctum for session-based auth too
});

// Optional: Add an interceptor to attach the token for all outgoing requests
// This can centralize token management
api.interceptors.request.use(
  (config) => {1
    const token = store.state.token; // Get token from local storage (persisted state)
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;